import axios from "axios";
// Create pastille
let mutationObserver;
export default class IACart {
    constructor() {
        this.run()
    }

    run() {
        // Create bullet for cart
        let pastille = document.createElement('span')
        pastille.classList.add('sub-pastille')
        pastille.textContent = "0"
        document.querySelector('.menu-item.is-cart').append(pastille)
    
        // WooCommerce add cart in page
        document.querySelector('.menu-item.is-cart').addEventListener('click', cart => {
            document.querySelector('.ia-block-cart').classList.toggle('is-active')
            document.querySelector('html').classList.toggle('no-scroll')
        })
        getCart()

        function getCart() {
            // Get all cart from woocommerce ajax
            return axios.get('/?wc-ajax=get_refreshed_fragments').then((response)=>{
                const result = JSON.parse(response.request.response)
                for(const [key, value] of Object.entries(result.fragments)){
                    var cart = document.createElement("div")
                    cart.classList.add('ia-block-cart')
                    cart.insertAdjacentHTML('beforeend',value)
                    document.querySelector('.section-default-inner, #main').append(cart)
                    updateCart()
                    addEvent()
                }
            })
        }
        
        function updateCart() {
            if(mutationObserver != undefined){
                mutationObserver.disconnect()
            }
            // Organize the cart layout
            document.querySelectorAll('.woocommerce-mini-cart-item.mini_cart_item').forEach((item)=>{
                const itemToMove = item.querySelector('.quantity')
                const container = item.querySelector('a:not([class])')
                const image = container.querySelector('img')
                const text = container.textContent;
                const itemText = document.createElement('span')
                const itemImage = document.createElement('span')
                itemText.classList.add('ia-block-cart__title')
                itemText.append(text)
                itemImage.classList.add('ia-block-cart__visual')
                itemImage.append(image)
                container.textContent = ""
                container.append(itemImage)
                container.append(itemText)
                itemText.append(itemToMove)
            })
            // Update carts item bullet
            document.querySelector('.sub-pastille').textContent = document.querySelectorAll('.woocommerce-mini-cart-item.mini_cart_item').length
            if(mutationObserver != undefined){
                observe(mutationObserver, document.querySelector('.ia-block-cart'))
            }
        }
    
        function addEvent(){
            document.querySelectorAll('.ia-block-cart').forEach(cart=>{
                cart.addEventListener('click', eventBackground => {
                    if(eventBackground.target == document.querySelector('.ia-block-cart')){
                        document.querySelector('.ia-block-cart').classList.toggle('is-active')
                        document.querySelector('html').classList.toggle('no-scroll')
                    }
                })
                // Add cart observer
                mutationObserver = new MutationObserver(function(mutations) {
                    mutations.forEach(mutation=>{
                        mutation.addedNodes.forEach(node=>{
                            if(node.className == 'widget_shopping_cart_content'){
                                updateCart()
                            }
                        })
                    })
                });
                observe(mutationObserver, cart)
            })
        }
    
        function observe(observer, cart) {
            observer.observe(cart, {
                childList: true,
                subtree: true,
            });
        }
    }

    
}
